import Box from '@mui/material/Box';
import Input from '@mui/material/Input';
import FilterUsers from './FilterUsers/FilterUsers';
import useFetchData from '../../../../../hooks/useFetchData';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Badge from '@mui/material/Badge';
import GroupIcon from '@mui/icons-material/Group';
import TextNotAssigned from '../../../../text/TextNotAssigned';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ASSESSMENT_TYPE_CUSTOM, ASSESSMENT_TYPE_STANDARD } from '../../constants/typeAssessment';
import './ReviewersPanel.css';

const ReviewersPanelSearch = ({
  handleClassSearch,
  handleUserSearch,
  classInputSearch,
  userInputSearch,
  users = [],
  reviewers = [],
  selectedUserIds = [],
  setSelectedUserIds,
  assessmentType = ASSESSMENT_TYPE_STANDARD
}) => {
  const { isLoading: isLoadingRoles, data: dataRoles = [] } = useFetchData('roles/standard');
  const [filteredRoles, setFilteredRoles] = useState([]);
  const [checkAllUsers, setCheckAllUsers] = useState(false);
  const [enableUserSearch, setEnableUserSearch] = useState(false);
  const filter = useSelector((state) => state?.filter?.assessmentReviewers?.filter || {});
  const open = useSelector((state) => state?.filter?.assessmentReviewers?.open || false);
  const userRoles = useSelector((state) => state?.session?.user?.roles || []);

  useEffect(() => {
    if (dataRoles && dataRoles?.length > 0) {
      const isMaestroUser = userRoles.find((role) => role?.id === 'Maestro');
      const notAllowedRoles = ['Student', 'Parent'];

      if (!isMaestroUser) {
        notAllowedRoles.push('Maestro');
      }

      const filteredRoles = dataRoles.filter((role) => !notAllowedRoles.includes(role?.id));
      setFilteredRoles(filteredRoles);
    }
  }, [dataRoles]);

  useEffect(() => {
    if (checkAllUsers) {
      const selectedUserCodes = users?.map((user) => user?.code);
      setSelectedUserIds(selectedUserCodes);
    } else {
      setSelectedUserIds([]);
    }
  }, [checkAllUsers]);

  useEffect(() => {
    if (filter && Object.keys(filter).length > 0 && !open) {
      setEnableUserSearch(true);
    } else {
      setEnableUserSearch(false);
      handleUserSearch({ target: { value: '' } });
      setCheckAllUsers(false);
    }
  }, [filter]);

  return (
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 1,
        display: 'flex'
        // gap: '1rem',
      }}
    >
      <Box
        sx={{
          width: '100%',
          backgroundColor: '#fbfcfd',
          position: 'relative',
          padding: '0 1rem'
        }}
      >
        <Box className='reviewers-panel__search'>
          <Box className='_reviewers-panel__search-container '>
            <div
              className='m-l-20 box-end reviewers-panel__search-input'
              style={{ width: 'auto', border: '1px solid #e2e8f0', borderRadius: 'calc(0.5rem - 2px)' }}
            >
              <Input
                className='reviewers-panel__search-input-input'
                startAdornment={<FontAwesomeIcon icon='search' style={{ marginRight: '1rem' }} />}
                type='text'
                value={classInputSearch}
                onChange={handleClassSearch}
                sx={{ width: '100%' }}
                placeholder={
                  ASSESSMENT_TYPE_CUSTOM === assessmentType
                    ? `Search reviewers by user's name`
                    : `Search classes by code or user's name`
                }
              />
            </div>
          </Box>
        </Box>
        {ASSESSMENT_TYPE_CUSTOM === assessmentType && (
          <Box
            sx={{
              backgroundColor: '#f2f2f2',
              height: '32px',
              padding: '1.5rem',
              display: 'flex',
              alignItems: 'center',
              border: '1px solid rgb(226, 232, 240)',
              borderRadius: 'calc(-2px + 0.5rem)',
              marginTop: '2rem'
            }}
          >
            <Box>
              <p style={{ fontWeight: 'bold', color: '#050a18' }}>
                Assigned Reviewers ({reviewers?.length || 0})
              </p>
              <span style={{ fontSize: '0.875rem', color: '#6b7280' }}>
                These users will review the assessment
              </span>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default ReviewersPanelSearch;
